module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOCAMAAAB5Au6AAAAAB3RJTUUH1gcaDScX1PmaiAAAAAlwSFlzAAAK8AAACvABQqw0mAAAAARnQU1BAACxjwv8YQUAAAASUExURf///316fZaSloB4cPj4+LGvsfPY2SMAAAABdFJOUwBA5thmAAAAVUlEQVR42oWPQQ4AIQgDC5X/f3kTjK41inOTTsACUQKElwTk2RIZQWImokDivkOUReC80XgQMh/C8pFN4Etw8ibMs93gqcVDGOV60b+FuShb7AZYCT5n4gR6NKV3iQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/categories/Status.png
// module id = 177
// module chunks = 0